/*================ AIRNEST LANDING PAGE SCRIPTS ================
  Compatible avec le thème Shopify Airnest
*/

(function() {
    'use strict';

    // ========================================
    // Initialisation au chargement du DOM
    // ========================================
    function initLandingPage() {
        initRotatingWord();
        initTypingAnimation();
        initComparisonToggle();
        initSolutionsCarousel();
        initFinancingCarousel();
        initAllinoneCarousel();
        initProjectsCarousel();
        initStepsCarousel();
        initTestimonialsCarousel();
        initFaqAccordion();
    }

    // ========================================
    // Section 1 : Animation du texte rotatif
    // ========================================
    function initRotatingWord() {
        const rotatingWord = document.getElementById('rotatingWord');
        if (!rotatingWord) return;

        // Récupérer les mots depuis data-words ou utiliser les valeurs par défaut
        let wordsAttr = rotatingWord.getAttribute('data-words');
        
        // Si pas de data-words, utiliser des valeurs par défaut
        if (!wordsAttr || wordsAttr.trim() === '') {
            wordsAttr = 'sans stress, sans effort, clé en main, sur mesure';
        }

        const words = wordsAttr.split(',').map(w => w.trim()).filter(w => w.length > 0);
        
        if (words.length <= 1) return;
        
        let currentIndex = 0;

        // S'assurer que le style initial est correct
        rotatingWord.style.opacity = '1';
        rotatingWord.style.transform = 'translateY(0)';

        function rotateWord() {
            // Animation de sortie
            rotatingWord.style.opacity = '0';
            rotatingWord.style.transform = 'translateY(-10px)';

            setTimeout(function() {
                currentIndex = (currentIndex + 1) % words.length;
                rotatingWord.textContent = words[currentIndex];
                
                // Reset position avant animation d'entrée
                rotatingWord.style.transform = 'translateY(10px)';
                
                // Force reflow pour que l'animation fonctionne
                rotatingWord.offsetHeight;
                
                // Animation d'entrée
                rotatingWord.style.opacity = '1';
                rotatingWord.style.transform = 'translateY(0)';
            }, 300);
        }

        // Démarrer l'animation après un délai initial
        setTimeout(function() {
            setInterval(rotateWord, 3000);
        }, 2000);
    }

    // ========================================
    // Animation typing (machine à écrire)
    // ========================================
    function initTypingAnimation() {
        const typingWord = document.getElementById('typingWord');
        if (!typingWord) return;

        // Récupérer les mots depuis le data-attribute de la section
        const heroSection = typingWord.closest('.an-hero');
        if (!heroSection) return;
        
        // Vérifier si l'animation est activée
        const typingEnabled = heroSection.getAttribute('data-typing-enabled');
        if (typingEnabled === 'false') {
            // Si l'animation est désactivée, ne rien faire
            return;
        }
        
        let wordsAttr = heroSection.getAttribute('data-typing-words');
        
        // Si pas de data-attribute, utiliser les valeurs par défaut
        if (!wordsAttr || wordsAttr.trim() === '') {
            wordsAttr = 'stress., imprévu., effort., investissement.';
        }

        const words = wordsAttr.split(',').map(w => w.trim()).filter(w => w.length > 0);
        
        if (words.length === 0) return;
        
        let currentWordIndex = 0;
        let currentCharIndex = 0;
        let isDeleting = false;
        let typingSpeed = 100;
        let deletingSpeed = 50;
        let pauseBetweenWords = 2000;

        function type() {
            const currentWord = words[currentWordIndex];
            
            if (isDeleting) {
                // Supprimer les caractères
                typingWord.textContent = currentWord.substring(0, currentCharIndex - 1);
                currentCharIndex--;
                typingSpeed = deletingSpeed;
                
                if (currentCharIndex === 0) {
                    isDeleting = false;
                    currentWordIndex = (currentWordIndex + 1) % words.length;
                    typingSpeed = 200; // Pause avant de commencer le nouveau mot
                }
            } else {
                // Ajouter les caractères
                typingWord.textContent = currentWord.substring(0, currentCharIndex + 1);
                currentCharIndex++;
                typingSpeed = 100;
                
                if (currentCharIndex === currentWord.length) {
                    isDeleting = true;
                    typingSpeed = pauseBetweenWords; // Pause avant de commencer à supprimer
                }
            }
            
            setTimeout(type, typingSpeed);
        }

        // Démarrer l'animation après un court délai
        setTimeout(type, 500);
    }

    // ========================================
    // Section 2 : Toggle Avec/Sans Airnest
    // ========================================
    function initComparisonToggle() {
        const toggleBtns = document.querySelectorAll('.an-toggle-btn');
        const comparisonPanels = document.querySelectorAll('.an-comparison-panel');
        const comparisonGrids = document.querySelectorAll('.an-comparison-grid');

        if (toggleBtns.length === 0) return;

        toggleBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const tab = btn.getAttribute('data-tab');

                // Mettre à jour les boutons actifs
                toggleBtns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                // Trouver le panel actif et le nouveau panel
                const activePanel = document.querySelector('.an-comparison-panel.active');
                const newPanel = Array.from(comparisonPanels).find(panel => panel.getAttribute('data-panel') === tab);

                // Si on clique sur le même onglet, ne rien faire
                if (activePanel === newPanel) return;

                // Retirer la classe active de l'ancien panel
                if (activePanel) {
                    activePanel.classList.remove('active');
                }

                // Ajouter la classe active au nouveau panel
                if (newPanel) {
                    newPanel.classList.add('active');
                }

                // Mettre à jour le fond du grid selon l'onglet actif
                comparisonGrids.forEach(grid => {
                    grid.classList.remove('active-positive', 'active-negative');
                    if (tab === 'avec') {
                        grid.classList.add('active-positive');
                    } else if (tab === 'sans') {
                        grid.classList.add('active-negative');
                    }
                });
            });
        });

        // Initialiser le fond au chargement
        const activeBtn = document.querySelector('.an-toggle-btn.active');
        if (activeBtn && comparisonGrids.length > 0) {
            const tab = activeBtn.getAttribute('data-tab');
            comparisonGrids.forEach(grid => {
                grid.classList.remove('active-positive', 'active-negative');
                if (tab === 'avec') {
                    grid.classList.add('active-positive');
                } else if (tab === 'sans') {
                    grid.classList.add('active-negative');
                }
            });
        }
    }

    // ========================================
    // Carousel des solutions (tactile)
    // ========================================
    function initSolutionsCarousel() {
        const solutionsTrack = document.getElementById('solutionsTrack');
        const solutionsCarousel = document.getElementById('solutionsCarousel');
        const solutionFilters = document.querySelectorAll('.an-solution-filter');

        if (!solutionsTrack || !solutionsCarousel) return;

        const solutionCards = solutionsTrack.querySelectorAll('.an-solution-card');
        const totalSolutions = solutionCards.length;
        let solutionsPosition = 0;
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let startTime = 0;
        let velocity = 0;

        function updateSolutionsCarousel() {
            const cardWidth = solutionCards[0] ? solutionCards[0].offsetWidth : solutionsCarousel.offsetWidth;
            const gap = window.innerWidth <= 600 ? solutionsCarousel.offsetWidth * 0.03 : 0;
            const maxPosition = Math.max(0, totalSolutions - 1);

            if (solutionsPosition > maxPosition) solutionsPosition = maxPosition;
            if (solutionsPosition < 0) solutionsPosition = 0;

            const translateX = solutionsPosition * (cardWidth + gap);
            solutionsTrack.style.transform = `translateX(-${translateX}px)`;
            solutionsTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

            solutionFilters.forEach((filter, index) => {
                filter.classList.toggle('active', index === solutionsPosition);
            });
        }

        function goToSlide(index) {
            solutionsPosition = index;
            updateSolutionsCarousel();
        }

        solutionFilters.forEach((filter, index) => {
            filter.addEventListener('click', () => {
                goToSlide(index);
            });
        });

        function getPositionX(event) {
            return event.touches ? event.touches[0].clientX : event.clientX;
        }

        function touchStart(event) {
            if (window.innerWidth > 600) return;
            event.preventDefault();
            startX = getPositionX(event);
            startTime = Date.now();
            isDragging = true;
            startTranslate = currentTranslate;
            solutionsTrack.style.transition = 'none';
            velocity = 0;
        }

        function touchMove(event) {
            if (!isDragging || window.innerWidth > 600) return;
            event.preventDefault();
            
            const previousX = currentX;
            currentX = getPositionX(event);
            const currentTime = Date.now();
            const timeDelta = currentTime - startTime;
            
            if (timeDelta > 0) {
                velocity = (currentX - previousX) / timeDelta;
            }
            
            currentTranslate = startTranslate + (currentX - startX);
            
            const cardWidth = solutionCards[0] ? solutionCards[0].offsetWidth : solutionsCarousel.offsetWidth;
            const gap = window.innerWidth <= 600 ? solutionsCarousel.offsetWidth * 0.03 : 0;
            const maxTranslate = (totalSolutions - 1) * (cardWidth + gap);
            const minTranslate = 0;
            
            if (currentTranslate > minTranslate) {
                currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.3;
            } else if (currentTranslate < -maxTranslate) {
                currentTranslate = -maxTranslate + (currentTranslate + maxTranslate) * 0.3;
            }
            
            solutionsTrack.style.transform = `translateX(${currentTranslate}px)`;
        }

        function touchEnd() {
            if (!isDragging || window.innerWidth > 600) return;
            isDragging = false;

            const cardWidth = solutionCards[0] ? solutionCards[0].offsetWidth : solutionsCarousel.offsetWidth;
            const gap = window.innerWidth <= 600 ? solutionsCarousel.offsetWidth * 0.03 : 0;
            const moved = startX - currentX;
            const distance = Math.abs(moved);
            const threshold = (cardWidth + gap) * 0.15;
            const velocityThreshold = 0.3;

            if (distance > threshold || Math.abs(velocity) > velocityThreshold) {
                if (moved > 0 || velocity > velocityThreshold) {
                    solutionsPosition++;
                } else if (moved < 0 || velocity < -velocityThreshold) {
                    solutionsPosition--;
                }
            }

            updateSolutionsCarousel();
            currentTranslate = 0;
            velocity = 0;
        }

        updateSolutionsCarousel();
    }

    // ========================================
    // Carousel du financement (tactile)
    // ========================================
    function initFinancingCarousel() {
        const financingTrack = document.getElementById('financingTrack');
        const financingCarousel = document.getElementById('financingCarousel');
        const financingFilters = document.querySelectorAll('.an-financing-filter');

        if (!financingTrack || !financingCarousel) return;

        const financingCards = financingTrack.querySelectorAll('.an-financing-card');
        const totalFinancing = financingCards.length;
        let financingPosition = 0;
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let startTime = 0;
        let velocity = 0;

        function updateFinancingCarousel() {
            const cardWidth = financingTrack.offsetWidth;
            const gap = 0;
            const maxPosition = Math.max(0, totalFinancing - 1);

            if (financingPosition > maxPosition) financingPosition = maxPosition;
            if (financingPosition < 0) financingPosition = 0;

            const translateX = financingPosition * (cardWidth + gap);
            financingTrack.style.transform = `translateX(-${translateX}px)`;
            financingTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

            financingFilters.forEach((filter, index) => {
                filter.classList.toggle('active', index === financingPosition);
            });
        }

        function goToSlide(index) {
            financingPosition = index;
            updateFinancingCarousel();
        }

        financingFilters.forEach((filter, index) => {
            filter.addEventListener('click', () => {
                goToSlide(index);
            });
        });

        function getPositionX(event) {
            return event.touches ? event.touches[0].clientX : event.clientX;
        }

        function touchStart(event) {
            if (window.innerWidth > 600) return;
            event.preventDefault();
            startX = getPositionX(event);
            startTime = Date.now();
            isDragging = true;
            startTranslate = currentTranslate;
            financingTrack.style.transition = 'none';
            velocity = 0;
        }

        function touchMove(event) {
            if (!isDragging || window.innerWidth > 600) return;
            event.preventDefault();
            
            const previousX = currentX;
            currentX = getPositionX(event);
            const currentTime = Date.now();
            const timeDelta = currentTime - startTime;
            
            if (timeDelta > 0) {
                velocity = (currentX - previousX) / timeDelta;
            }
            
            currentTranslate = startTranslate + (currentX - startX);
            
            const cardWidth = financingTrack.offsetWidth;
            const gap = 0;
            const maxTranslate = (totalFinancing - 1) * (cardWidth + gap);
            const minTranslate = 0;
            
            if (currentTranslate > minTranslate) {
                currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.3;
            } else if (currentTranslate < -maxTranslate) {
                currentTranslate = -maxTranslate + (currentTranslate + maxTranslate) * 0.3;
            }
            
            financingTrack.style.transform = `translateX(${currentTranslate}px)`;
        }

        function touchEnd() {
            if (!isDragging || window.innerWidth > 600) return;
            isDragging = false;

            const cardWidth = financingTrack.offsetWidth;
            const gap = 0;
            const moved = startX - currentX;
            const distance = Math.abs(moved);
            const threshold = cardWidth * 0.15;
            const velocityThreshold = 0.3;

            if (distance > threshold || Math.abs(velocity) > velocityThreshold) {
                if (moved > 0 || velocity > velocityThreshold) {
                    financingPosition++;
                } else if (moved < 0 || velocity < -velocityThreshold) {
                    financingPosition--;
                }
            }

            updateFinancingCarousel();
            currentTranslate = 0;
            velocity = 0;
        }

        // Désactivation de la fonctionnalité tactile sur mobile - navigation uniquement via les boutons
        // if (window.innerWidth <= 600) {
        //     financingCarousel.addEventListener('touchstart', touchStart, { passive: false });
        //     financingCarousel.addEventListener('touchmove', touchMove, { passive: false });
        //     financingCarousel.addEventListener('touchend', touchEnd);
        // }

        updateFinancingCarousel();
    }

    // ========================================
    // Carousel All-in-One (tactile)
    // ========================================
    function initAllinoneCarousel() {
        /* Sur mobile, pas de carousel : contenu en bloc statique */
        if (window.innerWidth <= 600) return;

        const allinoneTrack = document.getElementById('allinoneTrack');
        const allinoneCarousel = document.getElementById('allinoneCarousel');

        if (!allinoneTrack || !allinoneCarousel) return;

        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let startTime = 0;
        let velocity = 0;

        function getPositionX(event) {
            return event.touches ? event.touches[0].clientX : event.clientX;
        }

        function touchStart(event) {
            if (window.innerWidth > 600) return;
            event.preventDefault();
            startX = getPositionX(event);
            startTime = Date.now();
            isDragging = true;
            startTranslate = currentTranslate;
            allinoneTrack.style.transition = 'none';
            velocity = 0;
        }

        function touchMove(event) {
            if (!isDragging || window.innerWidth > 600) return;
            event.preventDefault();
            
            const previousX = currentX;
            currentX = getPositionX(event);
            const currentTime = Date.now();
            const timeDelta = currentTime - startTime;
            
            if (timeDelta > 0) {
                velocity = (currentX - previousX) / timeDelta;
            }
            
            currentTranslate = startTranslate + (currentX - startX);
            
            const cardWidth = allinoneTrack.offsetWidth;
            const gap = 0;
            const maxTranslate = 0;
            const minTranslate = 0;
            
            if (currentTranslate > minTranslate) {
                currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.3;
            } else if (currentTranslate < -maxTranslate) {
                currentTranslate = -maxTranslate + (currentTranslate + maxTranslate) * 0.3;
            }
            
            allinoneTrack.style.transform = `translateX(${currentTranslate}px)`;
        }

        function touchEnd() {
            if (!isDragging || window.innerWidth > 600) return;
            isDragging = false;

            const cardWidth = allinoneTrack.offsetWidth;
            const gap = 0;
            const moved = startX - currentX;
            const distance = Math.abs(moved);
            const threshold = cardWidth * 0.15;
            const velocityThreshold = 0.3;

            if (distance > threshold || Math.abs(velocity) > velocityThreshold) {
                // Pour l'instant, un seul slide, donc pas de navigation
            }

            allinoneTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            allinoneTrack.style.transform = `translateX(0px)`;
            currentTranslate = 0;
            velocity = 0;
        }

        if (window.innerWidth <= 600) {
            allinoneCarousel.addEventListener('touchstart', touchStart, { passive: false });
            allinoneCarousel.addEventListener('touchmove', touchMove, { passive: false });
            allinoneCarousel.addEventListener('touchend', touchEnd);
        }
    }

    // ========================================
    // Section 7 : Carousel des projets (tactile amélioré)
    // ========================================
    function initProjectsCarousel() {
        const projectsTrack = document.getElementById('projectsTrack');
        const projectsCarousel = document.getElementById('projectsCarousel');
        const projectsPrev = document.getElementById('projectsPrev');
        const projectsNext = document.getElementById('projectsNext');
        const projectsProgress = document.getElementById('projectsProgress');

        if (!projectsTrack) return;

        const projectCards = projectsTrack.querySelectorAll('.an-project-card');
        const totalProjects = projectCards.length;
        let projectsPosition = 0;
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let startTime = 0;
        let velocity = 0;
        let projectsExpanded = false;
        let pressedProjectLink = null;
        let shouldDrag = false;

        function expandProjectsCarousel() {
            if (projectsExpanded || !projectsCarousel) return;
            projectsCarousel.style.width = '100%';
            projectsCarousel.style.marginLeft = 'auto';
            projectsCarousel.style.marginRight = 'auto';
            projectsExpanded = true;
        }

        function collapseProjectsCarousel() {
            if (!projectsExpanded || !projectsCarousel) return;
            // On remet à l'état défini par le CSS (largeur/centrage)
            projectsCarousel.style.width = '';
            projectsCarousel.style.marginLeft = '';
            projectsCarousel.style.marginRight = '';
            projectsExpanded = false;
        }

        function getVisibleProjects() {
            if (window.innerWidth <= 600) return 2;
            if (window.innerWidth <= 1024) return 2;
            if (window.innerWidth <= 1200) return 3;
            return 4;
        }

        function getProjectsCardWidth() {
            const g = getProjectsGap();
            const vis = getVisibleProjects();
            if (window.innerWidth <= 600 && projectCards.length) {
                return projectCards[0].offsetWidth;
            }
            if (!projectsCarousel) return (projectsTrack.offsetWidth - g) / vis;
            const w = projectsCarousel.offsetWidth;
            if (window.innerWidth <= 600) return (w - g) / 2;
            if (window.innerWidth <= 1024) return (w - g) / 2;
            if (window.innerWidth <= 1200) return (w - g * 2) / 3;
            return (w - g * 3) / 4;
        }

        function getProjectsGap() {
            return window.innerWidth <= 600 ? 16 : 24;
        }

        function updateProjectsCarousel() {
            const visibleProjects = getVisibleProjects();
            const maxPosition = Math.max(0, totalProjects - visibleProjects);

            if (projectsPosition > maxPosition) projectsPosition = maxPosition;
            if (projectsPosition < 0) projectsPosition = 0;

            // Etat "disabled" des flèches (comme LP Comment ça marche)
            if (projectsPrev) projectsPrev.classList.toggle('is-disabled', projectsPosition === 0);
            if (projectsNext) projectsNext.classList.toggle('is-disabled', projectsPosition >= maxPosition);

            const cardWidth = getProjectsCardWidth();
            const g = getProjectsGap();
            const translateX = projectsPosition * (cardWidth + g);
            projectsTrack.style.transform = `translateX(-${translateX}px)`;
            projectsTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

            if (projectsProgress && window.innerWidth < 768) {
                const progressWidth = ((projectsPosition + visibleProjects) / totalProjects) * 100;
                projectsProgress.style.width = `${Math.min(progressWidth, 100)}%`;
            }

            // Si on revient au premier slide, on repasse en largeur "initiale" (CSS)
            if (projectsExpanded && projectsPosition === 0) {
                collapseProjectsCarousel();
            }
        }

        function getPositionX(event) {
            return event.touches ? event.touches[0].clientX : event.clientX;
        }

        function touchStart(event) {
            if (event.type === 'mousedown' && event.button !== 0) return;
            if (event.type === 'mousedown' && window.innerWidth >= 768) return;
            if (event.type === 'touchstart' && window.innerWidth > 600) return;
            // Si on touche un lien <a> (toute la carte est cliquable), on fait:
            // - swipe: on déplace le carrousel et on ne navigue pas
            // - tap: on navigue manuellement
            pressedProjectLink = event.target && event.target.closest ? event.target.closest('a') : null;
            const touchOnLink = !!pressedProjectLink;
            // Si on tape sur un lien (pas un swipe), on laisse le navigateur gérer.
            if (!touchOnLink) event.preventDefault();
            startX = getPositionX(event);
            currentX = startX;
            startTime = Date.now();
            isDragging = true;
            shouldDrag = !touchOnLink;
            const cardWidth = getProjectsCardWidth();
            const g = getProjectsGap();
            startTranslate = -projectsPosition * (cardWidth + g);
            currentTranslate = startTranslate;
            projectsTrack.style.transition = 'none';
            velocity = 0;
            if (event.type === 'mousedown') {
                document.addEventListener('mousemove', touchMove);
                document.addEventListener('mouseup', projectsDragEndOnce);
            }
        }

        function projectsDragEndOnce() {
            document.removeEventListener('mousemove', touchMove);
            document.removeEventListener('mouseup', projectsDragEndOnce);
            touchEnd();
        }

        function touchMove(event) {
            if (!isDragging) return;
            
            const previousX = currentX;
            currentX = getPositionX(event);
            const currentTime = Date.now();
            const timeDelta = currentTime - startTime;

            if (!shouldDrag) {
                const cardWidth = getProjectsCardWidth();
                const threshold = cardWidth * 0.15;
                const distance = Math.abs(startX - currentX);
                if (distance < threshold) {
                    return; // Pas encore un swipe => on laisse le tap gérer la navigation
                }
                shouldDrag = true;
            }

            if (event.cancelable) event.preventDefault();
            
            if (timeDelta > 0) {
                velocity = (currentX - previousX) / timeDelta;
            }
            
            currentTranslate = startTranslate + (currentX - startX);
            
            const cardWidth = getProjectsCardWidth();
            const g = getProjectsGap();
            const visibleProjects = getVisibleProjects();
            const maxTranslate = (totalProjects - visibleProjects) * (cardWidth + g);
            const minTranslate = 0;
            
            if (currentTranslate > minTranslate) {
                currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.3;
            } else if (currentTranslate < -maxTranslate) {
                currentTranslate = -maxTranslate + (currentTranslate + maxTranslate) * 0.3;
            }
            
            projectsTrack.style.transform = `translateX(${currentTranslate}px)`;
        }

        function touchEnd() {
            if (!isDragging) return;
            isDragging = false;

            const cardWidth = getProjectsCardWidth();
            const moved = startX - currentX;
            const distance = Math.abs(moved);
            const threshold = cardWidth * 0.15;
            const velocityThreshold = 0.3;

            const isSwipe = shouldDrag || distance > threshold || Math.abs(velocity) > velocityThreshold;
            if (isSwipe) {
                if (moved > 0 || velocity > velocityThreshold) {
                    projectsPosition++;
                } else if (moved < 0 || velocity < -velocityThreshold) {
                    projectsPosition--;
                }
                updateProjectsCarousel();
            }

            currentTranslate = 0;
            velocity = 0;
            pressedProjectLink = null;
            shouldDrag = false;
        }

        if (projectsPrev && projectsNext) {
            projectsPrev.addEventListener('click', () => {
                if (projectsPosition > 0) {
                    projectsPosition--;
                    updateProjectsCarousel();
                }
            });

            projectsNext.addEventListener('click', () => {
                expandProjectsCarousel();
                const visibleProjects = getVisibleProjects();
                const maxPosition = totalProjects - visibleProjects;
                if (projectsPosition < maxPosition) {
                    projectsPosition++;
                    updateProjectsCarousel();
                }
            });
        }

        if (projectsCarousel) {
            projectsCarousel.addEventListener('touchstart', (event) => {
                touchStart(event);
            }, { passive: false });
            projectsCarousel.addEventListener('touchmove', touchMove, { passive: false });
            projectsCarousel.addEventListener('touchend', touchEnd);
            projectsCarousel.addEventListener('mousedown', (event) => {
                touchStart(event);
            });
        }

        window.addEventListener('resize', updateProjectsCarousel);
        updateProjectsCarousel();
    }

    // ========================================
    // Section 9 : Carousel des étapes (tactile amélioré)
    // ========================================
    function initStepsCarousel() {
        const stepsTrack = document.getElementById('stepsTrack');
        const stepsCarousel = document.getElementById('stepsCarousel');
        const stepsPrev = document.getElementById('stepsPrev');
        const stepsNext = document.getElementById('stepsNext');
        const stepsProgress = document.getElementById('stepsProgress');

        if (!stepsTrack) return;

        const stepCards = stepsTrack.querySelectorAll('.an-step-card');
        const totalSteps = stepCards.length;
        let stepsPosition = 0;
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let startTime = 0;
        let velocity = 0;
        let stepsExpanded = false;

        function expandStepsCarousel() {
            if (stepsExpanded || !stepsCarousel) return;
            if (window.innerWidth < 768) return;
            stepsCarousel.classList.add('is-expanded');
            stepsExpanded = true;
        }

        function getVisibleSteps() {
            if (window.innerWidth <= 600) return 1;
            if (window.innerWidth <= 1024) return 2;
            return 2.5;
        }

        function getStepsCardWidth() {
            const gap = getStepsGap();
            const viewportW = stepsCarousel ? stepsCarousel.offsetWidth : stepsTrack.offsetWidth;
            if (window.innerWidth <= 600) {
                return viewportW * 0.9;
            }
            if (window.innerWidth <= 1024) {
                return (viewportW - gap) / 2;
            }
            return (viewportW - gap * 2) / 2.5;
        }

        function getStepsGap() {
            return window.innerWidth <= 600 ? 5 : 24;
        }

        function updateStepsCarousel() {
            const visibleSteps = Math.floor(getVisibleSteps());
            const maxPosition = Math.max(0, totalSteps - visibleSteps);

            if (stepsPosition > maxPosition) stepsPosition = maxPosition;
            if (stepsPosition < 0) stepsPosition = 0;

            const cardWidth = getStepsCardWidth();
            const gap = getStepsGap();
            const translateX = stepsPosition * (cardWidth + gap);
            stepsTrack.style.transform = `translateX(-${translateX}px)`;
            stepsTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

            if (window.innerWidth <= 600 && stepsCarousel) {
                stepsCarousel.style.setProperty('--steps-card-w', cardWidth + 'px');
            }

            if (stepsProgress) {
                const progressWidth = ((stepsPosition + 1) / totalSteps) * 100;
                stepsProgress.style.width = `${progressWidth}%`;
            }

            // Met à jour l'état actif/inactif de la flèche gauche
            if (stepsPrev) {
                if (stepsPosition === 0) {
                    stepsPrev.classList.add('is-disabled');
                } else {
                    stepsPrev.classList.remove('is-disabled');
                }
            }
        }

        function getPositionX(event) {
            return event.touches ? event.touches[0].clientX : event.clientX;
        }

        function dragStart(event) {
            if (event.type === 'mousedown' && event.button !== 0) return;
            event.preventDefault();
            startX = getPositionX(event);
            currentX = startX;
            startTime = Date.now();
            isDragging = true;
            const cardWidth = getStepsCardWidth();
            const gap = getStepsGap();
            startTranslate = -stepsPosition * (cardWidth + gap);
            currentTranslate = startTranslate;
            stepsTrack.style.transition = 'none';
            velocity = 0;
            if (event.type === 'mousedown') {
                document.addEventListener('mousemove', dragMove);
                document.addEventListener('mouseup', dragEndOnce);
            }
        }

        function dragEndOnce() {
            document.removeEventListener('mousemove', dragMove);
            document.removeEventListener('mouseup', dragEndOnce);
            dragEnd();
        }

        function dragMove(event) {
            if (!isDragging) return;
            event.preventDefault();
            
            const previousX = currentX;
            currentX = getPositionX(event);
            const currentTime = Date.now();
            const timeDelta = currentTime - startTime;
            
            if (timeDelta > 0) {
                velocity = (currentX - previousX) / timeDelta;
            }
            
            currentTranslate = startTranslate + (currentX - startX);
            
            const cardWidth = getStepsCardWidth();
            const gap = getStepsGap();
            const visibleSteps = Math.floor(getVisibleSteps());
            const maxTranslate = (totalSteps - visibleSteps) * (cardWidth + gap);
            const minTranslate = 0;
            
            if (currentTranslate > minTranslate) {
                currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.3;
            } else if (currentTranslate < -maxTranslate) {
                currentTranslate = -maxTranslate + (currentTranslate + maxTranslate) * 0.3;
            }
            
            stepsTrack.style.transform = `translateX(${currentTranslate}px)`;
        }

        function dragEnd() {
            if (!isDragging) return;
            isDragging = false;

            const cardWidth = getStepsCardWidth();
            const moved = startX - currentX;
            const distance = Math.abs(moved);
            const threshold = cardWidth * 0.15;
            const velocityThreshold = 0.3;

            if (distance > threshold || Math.abs(velocity) > velocityThreshold) {
                if (moved > 0 || velocity > velocityThreshold) {
                    stepsPosition++;
                } else if (moved < 0 || velocity < -velocityThreshold) {
                    stepsPosition--;
                }
            }

            updateStepsCarousel();
            currentTranslate = 0;
            velocity = 0;
        }

        if (stepsPrev && stepsNext) {
            stepsPrev.addEventListener('click', () => {
                expandStepsCarousel();
                if (stepsPosition > 0) {
                    stepsPosition--;
                    updateStepsCarousel();
                }
            });

            stepsNext.addEventListener('click', () => {
                expandStepsCarousel();
                const visibleSteps = Math.floor(getVisibleSteps());
                const maxPosition = totalSteps - visibleSteps;
                if (stepsPosition < maxPosition) {
                    stepsPosition++;
                    updateStepsCarousel();
                }
            });
        }

        if (stepsCarousel) {
            // Support tactile (mobile)
            stepsCarousel.addEventListener('touchstart', (event) => {
                expandStepsCarousel();
                dragStart(event);
            }, { passive: false });
            stepsCarousel.addEventListener('touchmove', dragMove, { passive: false });
            stepsCarousel.addEventListener('touchend', dragEnd);
            // Support souris (desktop) : mousedown uniquement, mousemove/mouseup ajoutés sur document dans dragStart
            stepsCarousel.addEventListener('mousedown', (event) => {
                expandStepsCarousel();
                dragStart(event);
            });
        }

        window.addEventListener('resize', updateStepsCarousel);
        updateStepsCarousel();
    }

    // ========================================
    // Section 11 : Carousel des témoignages (tactile mobile)
    // ========================================
    function initTestimonialsCarousel() {
        const testimonialsTrack = document.getElementById('testimonialsTrack');
        const testimonialsCarousel = document.getElementById('testimonialsCarousel');
        const testimonialsPrev = document.getElementById('testimonialsPrev');
        const testimonialsNext = document.getElementById('testimonialsNext');

        if (!testimonialsTrack || !testimonialsPrev || !testimonialsNext) return;

        const testimonialCards = testimonialsTrack.children;
        const totalTestimonials = testimonialCards.length;
        let testimonialsPosition = 0;
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let startTime = 0;
        let velocity = 0;

        function syncTestimonialsCarouselWidth() {
            if (!testimonialsCarousel) return;
            if (window.innerWidth < 768) {
                testimonialsCarousel.style.width = '';
                testimonialsCarousel.style.marginLeft = '';
                testimonialsCarousel.style.marginRight = '';
                return;
            }
            if (testimonialsPosition === 0) {
                testimonialsCarousel.style.width = '90%';
                testimonialsCarousel.style.marginLeft = 'auto';
                testimonialsCarousel.style.marginRight = '0';
            } else {
                testimonialsCarousel.style.width = '100%';
                testimonialsCarousel.style.marginLeft = 'auto';
                testimonialsCarousel.style.marginRight = 'auto';
            }
        }

        function getVisibleTestimonials() {
            if (window.innerWidth <= 600) return 1;
            if (window.innerWidth <= 1024) return 2;
            return 3;
        }

        function getTestimonialsGap() {
            return window.innerWidth <= 600 ? 16 : 24;
        }

        function getTestimonialsCardWidth() {
            const gap = getTestimonialsGap();
            const container = testimonialsCarousel || testimonialsTrack.parentElement;
            const w = container ? container.offsetWidth : testimonialsTrack.offsetWidth;
            if (window.innerWidth <= 600) {
                if (testimonialCards.length && testimonialCards[0].offsetWidth) {
                    return testimonialCards[0].offsetWidth;
                }
                return w * 0.85;
            }
            if (window.innerWidth <= 1024) return (w - gap) / 2;
            return (w - gap * 2) / 3;
        }

        function updateTestimonialsCarousel() {
            const visibleTestimonials = getVisibleTestimonials();
            const maxPosition = Math.max(0, totalTestimonials - visibleTestimonials);

            if (testimonialsPosition > maxPosition) testimonialsPosition = maxPosition;
            if (testimonialsPosition < 0) testimonialsPosition = 0;

            const cardWidth = getTestimonialsCardWidth();
            const gap = getTestimonialsGap();
            const translateX = testimonialsPosition * (cardWidth + gap);
            testimonialsTrack.style.transform = `translateX(-${translateX}px)`;
            testimonialsTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            syncTestimonialsCarouselWidth();
        }

        function getPositionX(event) {
            return event.touches ? event.touches[0].clientX : event.clientX;
        }

        function touchStart(event) {
            if (event.type === 'mousedown' && event.button !== 0) return;
            if (event.type === 'touchstart' && window.innerWidth > 600) return;
            event.preventDefault();
            startX = getPositionX(event);
            currentX = startX;
            startTime = Date.now();
            isDragging = true;
            const cardWidth = getTestimonialsCardWidth();
            const gap = getTestimonialsGap();
            startTranslate = -testimonialsPosition * (cardWidth + gap);
            currentTranslate = startTranslate;
            testimonialsTrack.style.transition = 'none';
            velocity = 0;
            if (event.type === 'mousedown') {
                document.addEventListener('mousemove', touchMove);
                document.addEventListener('mouseup', testimonialsDragEndOnce);
            }
        }

        function testimonialsDragEndOnce() {
            document.removeEventListener('mousemove', touchMove);
            document.removeEventListener('mouseup', testimonialsDragEndOnce);
            touchEnd();
        }

        function touchMove(event) {
            if (!isDragging) return;
            event.preventDefault();
            const previousX = currentX;
            currentX = getPositionX(event);
            const currentTime = Date.now();
            if (currentTime - startTime > 0) {
                velocity = (currentX - previousX) / (currentTime - startTime);
            }
            currentTranslate = startTranslate + (currentX - startX);
            const cardWidth = getTestimonialsCardWidth();
            const gap = getTestimonialsGap();
            const visibleTestimonials = getVisibleTestimonials();
            const maxTranslate = (totalTestimonials - visibleTestimonials) * (cardWidth + gap);
            const minTranslate = 0;
            if (currentTranslate > minTranslate) {
                currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.3;
            } else if (currentTranslate < -maxTranslate) {
                currentTranslate = -maxTranslate + (currentTranslate + maxTranslate) * 0.3;
            }
            testimonialsTrack.style.transform = `translateX(${currentTranslate}px)`;
        }

        function touchEnd() {
            if (!isDragging) return;
            isDragging = false;
            const cardWidth = getTestimonialsCardWidth();
            const moved = startX - currentX;
            const distance = Math.abs(moved);
            const threshold = cardWidth * 0.15;
            const velocityThreshold = 0.3;
            if (distance > threshold || Math.abs(velocity) > velocityThreshold) {
                if (moved > 0 || velocity > velocityThreshold) {
                    testimonialsPosition++;
                } else if (moved < 0 || velocity < -velocityThreshold) {
                    testimonialsPosition--;
                }
            }
            updateTestimonialsCarousel();
            currentTranslate = 0;
            velocity = 0;
        }

        testimonialsPrev.addEventListener('click', () => {
            if (testimonialsPosition > 0) {
                testimonialsPosition--;
                updateTestimonialsCarousel();
            }
        });

        testimonialsNext.addEventListener('click', () => {
            const visibleTestimonials = getVisibleTestimonials();
            const maxPosition = totalTestimonials - visibleTestimonials;
            if (testimonialsPosition < maxPosition) {
                testimonialsPosition++;
                updateTestimonialsCarousel();
            }
        });


        if (testimonialsCarousel) {
            testimonialsCarousel.addEventListener('touchstart', touchStart, { passive: false });
            testimonialsCarousel.addEventListener('touchmove', touchMove, { passive: false });
            testimonialsCarousel.addEventListener('touchend', touchEnd);
            testimonialsCarousel.addEventListener('mousedown', touchStart);
        }

        window.addEventListener('resize', updateTestimonialsCarousel);
        updateTestimonialsCarousel();
    }

    // ========================================
    // Section 14 : Accordion FAQ
    // ========================================
    function initFaqAccordion() {
        const faqItems = document.querySelectorAll('.an-faq-item');
        const faqQuestions = document.querySelectorAll('.an-faq-question');

        if (faqQuestions.length === 0) return;

        function setMobileFaqState() {
            if (window.innerWidth <= 600) {
                faqItems.forEach((item, i) => {
                    if (i === 0) item.classList.add('active');
                    else item.classList.remove('active');
                });
            }
        }
        setMobileFaqState();
        window.addEventListener('resize', setMobileFaqState);

        faqQuestions.forEach(question => {
            question.addEventListener('click', () => {
                const faqItem = question.parentElement;
                const isActive = faqItem.classList.contains('active');

                document.querySelectorAll('.an-faq-item').forEach(item => {
                    item.classList.remove('active');
                });

                if (!isActive) {
                    faqItem.classList.add('active');
                }
            });
        });
    }

    // ========================================
    // Lancement
    // ========================================
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLandingPage);
    } else {
        initLandingPage();
    }

})();
